<template>
  <div
    class="menu-mobile d-flex d-lg-none justify-content-center"
  >
    <div class="mt-5" v-if="authTokenExists">
      <v-coin-account-progress-bar
        @click="routeTo({name: 'reviewer-dashboard'})"
      />

      <hr class="mt-3"/>
      <div>
        <button
          class="btn btn-block btn-secondary"
          @click="routeTo({name: 'organisation-dashboard'})"
          v-if="org"
        >
          <span class="d-flex align-items-center">
            <img
              v-if="org.logo"
              :src="org.logo"
              class="img-thumbnail img-navbar mr-2"
              alt="logo"
            />
            <i v-else class="fa fa-building text-light mr-2"></i>

            &nbsp;{{ org.name }}
          </span>
        </button>

        <button
          class="mt-2 btn btn-block btn-secondary"
          @click="routeTo({ name: 'user-profile' })"
        >
          <i class="fa fa-user text-light mr-2"></i> &nbsp;{{ $t('phrase.my_account') }}
        </button>

        <hr class="mt-3"/>

        <a
          :href="getBackendUrl('/auth/logout/')"
          class="btn btn-block btn-secondary"
        >
          <i class="fa fa-power-off text-danger mr-2"></i> &nbsp;
          {{ $t('word.logout') }}
        </a>
      </div>
    </div>
    <div class="mt-5" v-else>
      <a
        href="/voor-bedrijven/"
        class="mb-2 btn btn-block btn-link text-white"
      >
        {{ $t('phrase.for_companies') }}
      </a>
      <a
        href="https://commercialreview.nl/over-ons/"
        class="mb-2 btn btn-block btn-link text-white"
      >
        {{ $t('phrase.about_us') }}
      </a>
      <hr/>
      <div class="mb-2">
        <button
          class="btn btn-danger btn-block text-white hide-arrow"
          @click="routeTo({ name: 'public-register-commercial' })"
        >
          <i class="fa fa-plus"></i> {{ $t('phrase.register_commercial') }}
        </button>
      </div>

      <div class="mb-2">
        <v-register-dropdown
          @selected="(registerAs) => {routeTo({name: 'register-as', params: { as: registerAs }})}"
        />
      </div>

      <v-button
        text="word.login"
        @click="routeTo({name: 'login'})"
        :block="true"
        icon="sign-in-alt"
      />
    </div>
  </div>
</template>

<script>
import RegisterDropdown from '@/common/components/auth/RegisterDropdown.vue';
import CoinAccountProgressBar from '@/common/components/coins/CoinAccountProgressBar.vue';
import Button from '@/common/components/Button.vue';
import { mapGetters } from 'vuex';
import { getBackendUrl } from '@/common/utils/api';

export default {
  name: 'MobileNav',
  components: {
    'v-button': Button,
    'v-coin-account-progress-bar': CoinAccountProgressBar,
    'v-register-dropdown': RegisterDropdown,
  },
  data() {
    return {
      showCommercialDropdown: false,
      show: false,
    };
  },
  computed: {
    ...mapGetters([
      'authTokenExists',
      'org',
      'user',
    ]),
  },
  methods: {
    getBackendUrl,
    routeTo(conf) {
      this.$emit('close');
      this.$router.push(conf);
    },
  },
  created() {
    this.show = true;
  },
};
</script>

<style scoped>
.img-navbar {
  width: 15px;
  height: auto;
}

.menu-mobile {
  padding-top: 90px;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.9);
  position: fixed;
  overflow: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
